jQuery(document).ready(function() {
    jQuery('.radiotab input[type="radio"]').change(function() {
        var selectedValue = jQuery(this).val();

        // Remove "active" class from all parent divs
        jQuery('.radiotab').removeClass('active');

        // Add "active" class to the selected parent div
        jQuery(this).closest('.radiotab').addClass('active');

        // Show the corresponding select element
        jQuery('.select-container').removeClass('show');
        jQuery('.select-container[dataname="' + selectedValue + '"]').addClass('show');
    });
});


jQuery(document).ready(function() {
    var kategoriaselect = jQuery('.kategoriaselect');

    jQuery('.valitsekategoriat').on('mousedown keydown', function(event) {
      if (event.type === 'mousedown' || (event.type === 'keydown' && event.which === 32)) {
        event.preventDefault(); // Prevent default actions (e.g., opening dropdown menu)
        if (kategoriaselect.hasClass('activeselect')) {
          kategoriaselect.removeClass('activeselect');
        } else {
          kategoriaselect.addClass('activeselect');
        }
      }
    });

    jQuery(document).on('mousedown', function(event) {
      if (!jQuery(event.target).closest('.select-container').length) {
        kategoriaselect.removeClass('activeselect');
      }
    });

    jQuery(window).on('resize', function() {
        kategoriaselect.removeClass('activeselect');
      });

  });

